import { PartialStateV9, StatePreV9 } from './9_effective_zaehlstueck_interfaces';

export const effectiveZaehlstueck = (
  previousState: StatePreV9,
  newVersion: number,
): PartialStateV9 => {
  const newState: PartialStateV9 = {
    ...previousState,
    version: newVersion,
  };
  if (previousState.anzahlZaehlstuecke) {
    newState.effectiveZaehlstuecke =
      previousState.anzahlZaehlstuecke + previousState.unfallZaehlstuecke;
  }
  return newState;
};
